export * from './slice';
import { appSlice } from './slice';

export const {
  storeAppState,
  storeCreateSwapStep,
  addOrRemoveSelectedNFT,
  removeSelectedNFT,
  changeNFTAmount,
  clearSelectedNFTs,
  storeAnswerSwapStep,
  addRecipient,
  storeSwapResolvedData,
  resetAppState,
  setActiveSwap,
  addEth,
  setEthInputOpen,
  setEthPrice,
  setWalletDropdownOpen,
  setRedirectRouteAfterLoginSuccess,
} = appSlice.actions;
